import { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { Link } from "@brexhq/next/src/components/shared/Link";
import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";

import type { INavigation } from "../../types";

const OuterContainer = styled(Container)(({ theme }) => ({
  borderTop: `1px solid ${theme.colors.border.default}`,
  padding: theme.spacing.SML.sml,
}));

const RegularLinksContainer = styled(Container)({
  flexWrap: "wrap",
});

const RegularLink = styled(Link, {
  shouldForwardProp: () => {
    return true;
  },
})(() => ({
  width: "100%",
  flex: "1 0 45%",
  margin: 0,
  minWidth: "unset !important",
  whiteSpace: "nowrap",
  borderColor: "#D0D0D0",
}));

const CTALink = styled(Link)(() => ({
  margin: 0,
  width: "100%",
}));

interface Props {
  links: INavigation["right"];
  darkModeNav?: boolean;
}

export default function BottomLinks({ links, darkModeNav }: Props) {
  const regularLinks = [...(links || [])];
  const ctaLink = regularLinks.pop();

  return (
    <OuterContainer direction="column" gap="xxsml">
      <RegularLinksContainer direction="row" gap="xxsml">
        {regularLinks.map((link) => {
          return (
            <RegularLink
              key={link.text}
              modifier="outline"
              to={link.link.to || link.link.toExternal || link.link.hash || "#"}
              noFollow={link.link.noFollow}
              label={link.text}
              component="Mobile nav bottom link"
              {...(darkModeNav
                ? { theme: "PrimaryDark" as ModuleThemeType & Theme }
                : {})}
            />
          );
        })}
      </RegularLinksContainer>
      {ctaLink && (
        <CTALink
          modifier="primary"
          to={
            ctaLink.link.to ||
            ctaLink.link.toExternal ||
            ctaLink.link.hash ||
            "#"
          }
          noFollow={ctaLink.link.noFollow}
          label={ctaLink.text}
          component="Mobile nav CTA"
        />
      )}
    </OuterContainer>
  );
}
